import React, { useEffect, useRef, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import GeneralLayout from "components/PageLayouts/GeneralLayout";
import GenericRecordSelection from "components/Records/RecordSelection/GenericRecordSelection";
import AddCoursePopup from "./Courses/AddCoursePopup";
import CoursesRightDrawer from "./Courses/CoursesRightDrawer";
import CoursesBottomDrawer from "./Courses/CoursesBottomDrawer";
import CoursesDetail from "./Courses/CoursesDetail";
import CourseEmptyPage from "./Courses/CoursesEmptyPage";
import { coursesAPI } from "api/Interactions/CoursesAPI";
import { Course } from "api/Interactions/InteractionsInterfaces";

const Courses: React.FC = () => {
  const [coursesData, setCoursesData] = useState<Course[]>([]);
  const [selectedCourse, setSelectedCourse] = useState<Course | null>(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    coursesAPI.getAll()
      .then((data) => {
        setCoursesData(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  const handleSelectCourse = async (id: number) => {
    try {
      const detail = await coursesAPI.getById(id);
      setSelectedCourse(detail);
    } catch {
      setSelectedCourse(null);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <GeneralLayout
      useLeftDrawer
      useRightDrawer
      useBottomDrawer
      defaultOpenLeft={true}
      defaultOpenRight={false}
      defaultOpenBottom={false}
      leftDrawerContent={
        <GenericRecordSelection<Course>
          items={coursesData}
          onSelect={(m) => handleSelectCourse(m.id)}
          AddPopupComponent={AddCoursePopup}
          onCreated={(newMsg) => {
            setCoursesData((prev) => [...prev, newMsg]);
            handleSelectCourse(newMsg.id);
          }}
          idKey="id"
          nameKey={(m) => m.name || `Course ${m.id}`}
          colorKey="interactionsPrimary"
          searchPlaceholder="Search courses..."
        />
      }
      rightDrawerContent={<CoursesRightDrawer courseId={selectedCourse?.id ?? 0} />}
      bottomDrawerContent={<CoursesBottomDrawer courseId={selectedCourse?.id ?? 0} />}
    >
      {selectedCourse ? (
        <CoursesDetail
          courseId={selectedCourse.id}
          onClose={() => setSelectedCourse(null)}
        />
      ) : (
        <CourseEmptyPage
          onCoursesCreated={(newCourse) => {
            setCoursesData((prev) => [...prev, newCourse]);
            handleSelectCourse(newCourse.id);
          }}
        />
      )}
    </GeneralLayout>
  );
};

export default Courses;
